export default defineNuxtRouteMiddleware((to) => {
  if (to.path === "/blog/all") {
    return navigateTo("/blog");
  }
});
